import { render, staticRenderFns } from "./AndiamoPaiEventiListPage.vue?vue&type=template&id=790a9a7a&scoped=true"
import script from "./AndiamoPaiEventiListPage.vue?vue&type=script&lang=js"
export * from "./AndiamoPaiEventiListPage.vue?vue&type=script&lang=js"
import style0 from "./AndiamoPaiEventiListPage.vue?vue&type=style&index=0&id=790a9a7a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "790a9a7a",
  null
  
)

export default component.exports